import { render, staticRenderFns } from "./Scorecard.vue?vue&type=template&id=874f8dcc"
import script from "./Scorecard.vue?vue&type=script&lang=js"
export * from "./Scorecard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports